import classNames from 'classnames';

import type { FC, PropsWithChildren } from 'react';
import React, { useEffect, useState } from 'react';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import LabelText from '../LabelText/LabelText';

import styles from './styles.module.scss';

interface FormElementProps {
  required?: boolean,
  error?: string,
  fullWidth?: boolean,
  isActive: boolean,
  hasValue: boolean,
  labelText?: string,
  id: string,
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void,
  onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void,
  small?: boolean,
  disabled?: boolean,
  className?: string,
}

const FormElement: FC<PropsWithChildren<FormElementProps>> = ({
  children,
  required = false,
  error = '',
  fullWidth,
  hasValue,
  labelText,
  id,
  onClick,
  onBlur,
  isActive,
  small,
  disabled,
  className,
}) => {
  const [inTop, setInTop] = useState(hasValue);

  const blurHandler = (e: React.FocusEvent<HTMLDivElement>) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  const clickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disabled) return;
    if (onClick) {
      onClick(e);
    }
  };

  useEffect(() => {
    if (!isActive) {
      setInTop(hasValue);
    } else {
      setInTop(true);
    }
  }, [hasValue, isActive]);

  const cn = classNames(styles.formElement, fullWidth && styles.fullWidth, small && styles.small, className);

  return (
    <div
      className={cn}
      onClick={clickHandler}
      onBlur={blurHandler}
    >
      {labelText && (
        <LabelText
          htmlFor={id}
          required={required}
          error={error}
          isActive={isActive}
          inTop={inTop}
          small={small}
          disabled={disabled}
        >
          {labelText}
        </LabelText>
      )}
      {children}
      {error && (
        <ErrorMessage>
          {error}
        </ErrorMessage>
      )}
    </div>
  );
};

export default FormElement;
